import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

const IconLoader = () => (
  <StaticImage
    className="img"
    src="../../images/logo_m_only.png"
    quality={100}
    formats={['AUTO', 'WEBP', 'AVIF']}
    alt="logo"
  />
);

export default IconLoader;
